function nomaintenanceTimer() {

  const startDate = new Date("2026-09-06T21:02:00+05:30");
  const blockDuration = 15 * 60 * 1000;

  const blockStart = startDate.getTime();
  const blockEnd = blockStart + blockDuration;
  const now = Date.now();

  if (now >= blockStart && now < blockEnd) {

    // Redirect to maintenance page
    window.location.href = "/pages/maintenance";

  }

}

nomaintenanceTimer();